import * as React from 'react';
import { IconProps } from '../../types/componentTypes';
import './ClickableIcon.less';

interface Props extends IconProps {
    icon: React.FunctionComponent<IconProps>;
    className?: string;
    disabled?: boolean;
    loading?: boolean;
    onClick: (event: React.MouseEvent<SVGSVGElement>) => void;
}

const ClickableIcon: React.FC<Props> = ({
    icon: Icon,
    disabled,
    loading,
    onClick,
    className = '',
    ...props
}: Props) => {
    const getIconClassName = () => {
        let iconClassName = 'clickable-icon';

        if (disabled) {
            iconClassName += ' disabled';
        }

        if (loading) {
            iconClassName += ' loading';
        }

        return `${iconClassName} ${className}`;
    };

    return <Icon className={getIconClassName()} onClick={disabled ? undefined : onClick} {...props} />;
};

export default ClickableIcon;
